// The topic, format, country and legend pages' copy, one language at a time. A page loads its own
// language with it (App.tsx), and until 2026-09-23 every one of those pages loaded all four
// languages, ~92 KB compressed. The tests register every language up front (tests/setup.ts), the
// way the dictionaries are. growth/content/index.js still assembles all of it for the tests and
// scripts that need everything.
import { registerTranscripts } from '../exampleTranscripts.js';

export const LOCALE_CONTENT_LOADERS = {
  en: () => import('./nicheContent.en'),
  es: () => import('./nicheContent.es'),
  pt: () => import('./nicheContent.pt'),
  ar: () => import('./nicheContent.ar'),
  fr: () => import('./nicheContent.fr'),
  de: () => import('./nicheContent.de'),
};

const loaded = {};

/** Keep a language's content once it has loaded. */
export function registerLocaleContent(locale, content) {
  loaded[locale] = { niches: content.NICHES_OF_LOCALE, legends: content.LEGENDS_OF_LOCALE };
  // and what the language's example videos say (Turkish has no topic pages)
  registerTranscripts(content.TRANSCRIPTS_OF_LOCALE);
}

/** A loaded language's topic pages (`niches`, by id) and legends; empty until it has loaded. */
export function localeContent(locale) {
  return loaded[locale] || { niches: {}, legends: {} };
}

/** Load a language's content (once) and keep it. */
export function loadLocaleContent(locale) {
  const load = LOCALE_CONTENT_LOADERS[locale];
  if (!load) return Promise.resolve();
  if (loaded[locale]) return Promise.resolve();
  return load().then((content) => registerLocaleContent(locale, content));
}
